<section class="panel"><h2>Reasignar usuarios responsables</h2>
<sr-admin-data-table label="Responsables por proyecto" [rows]="rows()" [columns]="columns" [actions]="actions" (action)="open($event)" />
@if(selected){<sr-reasignar-responsable [assignment]="selected" [readOnly]="readOnly" (closed)="selected=null" />}
</section>